import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDeviceList } from "../../../../actions/SelectDevice";
import Loader from "../../../../components/shared/loader/Loader";
import { 
    LOCALSESSIONDATAKEYS, 
    NATIVE_APP_SUBSCRIPTION_ATTRIBUTE 
} from "../../../../constants/AppConstants";
import { 
    buildDirectServicePageQSNativeApp,
    buildOneBenefitPageQSNAtiveApp, 
    getNativeAppQueryParamsValuesByKey, 
    isEcoproOrBplusDirectServicePage, 
    updateNativeAppQueryParams_LocalStorage 
} from "../../../../constants/AppMethod";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { nativeAppRoutePaths } from "../../../../constants/Routes";
import { getLocalSessionData } from "../../../../utils/Authentication/handleUserSession";

const EcoProEnrollmentCheck = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
    const serialNumber = getNativeAppQueryParamsValuesByKey("device_serial_no");
    
    const {
        deviceList,
        error: deviceInfoListErr,
        success: deviceInfoListsuccess
    } = useSelector((state) => state.SelectDevice);

    useEffect(() => {
        dispatch(fetchDeviceList(UID));
         // eslint-disable-next-line
    }, [dispatch]);

    useEffect(() => {
       if(deviceInfoListsuccess || deviceInfoListErr){
            const devicesArr = deviceList?.devices;
            const isDeviceAvailable = (devicesArr) ? Object.values(devicesArr).filter((val) => {
                return (val.serialNumber === serialNumber && val.hasOwnProperty('service') && val.service) ? val.service.currentPlan : "";
            }) : false;
            const enrollmentStatus = (isDeviceAvailable.length > 0) ? NATIVE_APP_SUBSCRIPTION_ATTRIBUTE.ALREADY_ENROLLED : NATIVE_APP_SUBSCRIPTION_ATTRIBUTE.TO_BE_ENROLLED;
            const QS = (isEcoproOrBplusDirectServicePage()) ? buildDirectServicePageQSNativeApp(enrollmentStatus) : buildOneBenefitPageQSNAtiveApp(enrollmentStatus, NATIVE_APP_SUBSCRIPTION_ATTRIBUTE.SKIP);
            updateNativeAppQueryParams_LocalStorage(null, QS, LOCALSESSIONDATAKEYS.NATIVE_APP_AUTH_TOKEN_INFO);
            history.push(nativeAppRoutePaths.WEB_TO_APP_REDIRECTION);
       }
        // eslint-disable-next-line
    }, [deviceInfoListsuccess, deviceInfoListErr])

    return (
        <Loader />
    )
}

export default EcoProEnrollmentCheck;